import { promotionPage } from 'utils/pageTemplates/promotionPage';

const { getStaticProps, getStaticPaths, PromotionPageComponent } =
  promotionPage();

export { getStaticPaths, getStaticProps };
export default PromotionPageComponent;
